import { render, staticRenderFns } from "./JVxeDemo3.vue?vue&type=template&id=64b53782&scoped=true&"
import script from "./JVxeDemo3.vue?vue&type=script&lang=js&"
export * from "./JVxeDemo3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b53782",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64b53782')) {
      api.createRecord('64b53782', component.options)
    } else {
      api.reload('64b53782', component.options)
    }
    module.hot.accept("./JVxeDemo3.vue?vue&type=template&id=64b53782&scoped=true&", function () {
      api.rerender('64b53782', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jeecg/JVxeDemo/JVxeDemo3.vue"
export default component.exports